// NOSONAR
export const ROUTE_NAME = {
  GUARDIAN: "Guardian",
  PROFILE: "Profile",
  LOGIN: "Login",
  SIGNIN: "Signin",
  FORGOT_PASSWORD: "ForgotPassword", // NOSONAR - route name, not a password
  SIGNUP: "SignUp",
  SIGNUP_AND_SUBSCRIBE: "SignupAndSubscribe",
  USER_ON_BOARDING: "USER_ON_BOARDING",
  DASHBOARD: "Dashboard",
  MY_ESTATE_PLAN: "My Estate Plan",
  DIGITAL_VAULT: "Digital Vault",
  LEGACY: "Legacy",
  DOCUMENTS: "Documents",
  TUTORIAL: "Tutorial",
  CIRCLE: "Circle",
  ASSETS: "Assets",
  WISHES: "Wishes",
  PLAN_DOCUMENTS: "PlanDocuments",
  ESTATE_PLAN_CIRCLE: "EstatePlanCircle",
  ACCOUNT_AGENT: "Account Agent",
  EXECUTOR: "Executor",
  BENEFICIARIES: "Beneficiaries",
  CHOOSE_BENEFICIARIES: "Choose Beneficiaries",
  TRANSITION: "Transitions",
  HEALTH_POA: "Health POA",
  HEALTH_SUPPORT: "Health Support",
  FINANCIAL_POA: "Financial POA",
  OPENING_SETTINGS: "Opening Settings",
  CIRCLE_ONBOARDING: "Circle Onboarding",
  ASSETS_ONBOARDING: "Assets Onboarding",
  WISHES_ONBOARDING: "Wishes Onboarding",
  ESTATE_PLAN_ASSET: "Estate Plan Asset",
  CHOOSE_ASSETS: "Choose Assets",
  ADD_ASSETS_HOME: "Add Assets Home",
  ROLES: "Roles",
  ROLES_MAIN: "RolesMain",
  AGENT_PLAN_LIST: "AgentPlanList",
  AGENT_PLAN_DETAILS: "AgentPlanDetails",
  OTHER_ROLES: "OtherRoles",
  OTHER_PLAN_DETAILS: "OtherPlanDetails",
  ROLES_REQUESTS: "Requests",
  ROLES_REQUEST_DETAILS: "RequestsRequestDetails",
  SECURITY: "Security",
  SECURITY_MAIN: "SecurityMain",
  TRUSTEE: "Trustee",
  REVOCABLE_TRUST: "Revocable Trust",
  SPOUSAL_TRUST: "Spousal Trust",
  ADD_WISHES: "Add Wishes",
  CASH_BEQUEST: "Cash Bequest",
  DISINHERIT: "Disinherit",
  ASSETS_BEQUEST: "Assets Bequest",
  DEPENDENTS_TRUST: "Dependents Trust",
  LIFE_SUPPORT: "Life Support",
  PET_TRUST: "Pet Trust",
  BODY_HANDLING: "Body Handling",
  FUNERAL_PLANS: "Funeral Plans",
  REMAINDER_DISTRIBUTION: "Remainder Distribution",
  NOTIFICATIONS: "Notifications",
  ESTATE_PLAN_WISHES: "Estate Plan Wishes",
  NOT_FOUND: "NotFound",
  USER_INCAPACITATION: "User Incapacitation",
  FORBIDDEN_PAGE: "ForbiddenPage",
  AGENT_DIGITAL_VAULT: "Agent Digital Vault",
  TERMS: "Terms",
};

// NOSONAR
export const ROUTE_PATHS = {
  GUARDIAN: "/guardian",
  PROFILE: "/profile",
  LOGIN: "/",
  SIGNIN: "/signin",
  FORGOT_PASSWORD: "/forgot-password", // NOSONAR - route name, not a password
  SIGNUP: "/signup",
  SIGNUP_AND_SUBSCRIBE: "/signupsubscribe",
  USER_ON_BOARDING: "/user-onboarding",
  DASHBOARD: "/dashboard",
  MY_ESTATE_PLAN: "/my-estate-plan",
  DIGITAL_VAULT: "/digital-vault",
  LEGACY: "/legacy",
  DOCUMENTS: "/documents",
  TUTORIAL: "/tutorial",
  CIRCLE: "/circle",
  ASSETS: "/assets",
  WISHES: "/wishes",
  PLAN_DOCUMENTS: "/plan-documents",
  ESTATE_PLAN_CIRCLE: "/estate-plan-circle",
  ACCOUNT_AGENT: "/account-agent",
  EXECUTOR: "/executor",
  TRANSITION: "/transition",
  OPENING_SETTINGS: "/opening-settings",
  BENEFICIARIES: "/add-beneficiaries-home",
  CHOOSE_BENEFICIARIES: "/add-beneficiaries",
  HEALTH_POA: "/health-POA",
  HEALTH_SUPPORT: "/health-Support",
  FINANCIAL_POA: "/financial-POA",
  CIRCLE_ONBOARDING: `/circle-onboarding/:id?`,
  ASSETS_ONBOARDING: `/assets-onboarding/:id?`,
  WISHES_ONBOARDING: `/wishes-onboarding/:id?`,
  ESTATE_PLAN_ASSET: "/estate-plan-asset",
  CHOOSE_ASSETS: "/add-assets",
  ADD_ASSETS_HOME: "/add-assets-home",
  ROLES: "/roles",
  ROLES_AGENT: "/roles/agent",
  ROLES_AGENT_PLAN: "/roles/agent/plan/:id",
  ROLES_OTHER: "/roles/other",
  ROLES_REQUESTS: "/roles/requests",
  AGENT: "agent",
  OTHER: "other",
  REQUESTS: "requests",
  SECURITY: "/security",
  TRUSTEE: "/trustee",
  REVOCABLE_TRUST: "/revocable-trust",
  SPOUSAL_TRUST: "/spousal-trust",
  ADD_WISHES: "/add-wishes",
  CASH_BEQUEST: "/cash-bequest",
  DISINHERIT: "/disinherit",
  ASSETS_BEQUEST: "/assets-bequest",
  DEPENDENTS_TRUST: "/dependents-trust",
  LIFE_SUPPORT: "/life-support",
  PET_TRUST: "/pet-trust",
  BODY_HANDLING: "/body-handling",
  FUNERAL_PLANS: "/funeral-plans",
  REMAINDER_DISTRIBUTION: "/remainder-distribution",
  NOTIFICATIONS: "/notifications",
  ESTATE_PLAN_WISHES: "/estate-plan-wishes",
  USER_INCAPACITATION: "/report/incap",
  NOT_FOUND: "/:pathMatch(.*)*",
  FORBIDDEN_PAGE: "/forbidden",
  AGENT_DIGITAL_VAULT: "/agent-digital-vault/:id/:userId",
  TERMS: "/terms",
};
